export default "__VITE_ASSET__BjveXHw5__"